__webpack_require__.p = "https://v2-component.apps.qorcommerce.io/";